import { Button, MutedText, Stack } from '@volee/ui'

import { accountName, useDeviceAccounts, useSwitchAccount } from '../data/device-accounts.ts'
import { interpolate, messages } from '../messages/index.ts'

/** The accounts still on this phone once the one in use left or expired (spec #278, #302): none takes
 *  over by itself, so the sign-in offers them, each with its own refresh token and no password. */
export function DeviceAccountsToContinue() {
  const { list } = useDeviceAccounts()
  const switchAccount = useSwitchAccount()

  if (list.length === 0) return null
  return (
    <Stack gap="sm">
      <MutedText>{messages.signIn.onThisPhone}</MutedText>
      {list.map((account) => (
        <Button
          key={account.sub}
          variant="secondary"
          loading={switchAccount.isPending && switchAccount.variables === account.sub}
          disabled={switchAccount.isPending}
          onClick={() => {
            switchAccount.mutate(account.sub)
          }}
        >
          {interpolate(messages.signIn.continueAs, { name: accountName(account) })}
        </Button>
      ))}
    </Stack>
  )
}
